import { render, staticRenderFns } from "./OrdersCurrent.vue?vue&type=template&id=1683d504&"
import script from "./OrdersCurrent.vue?vue&type=script&lang=js&"
export * from "./OrdersCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports